module.exports = __webpack_public_path__ + "img/testAnalysis_a.4f048aca.png";